(function ($) {
    fn_nl_lib_anchor();

    $(".lib--parallax").find("img").parent().parallax();

    nl_lib_dialog.init(function () {
        $(document).find(".lib--dialog .part_ui_btn").nl_lib_ripple();
    });
    $("[data-switch]").nl_lib_switch();
    $(".part_ui_btn").nl_lib_ripple();

    var picture = document.createElement('picture'),
        strObj = '' + picture;
    if (strObj.indexOf("HTMLPictureElement") === -1 && !$("html").hasClass("ie")) {
        $.getScript($cdnjs.picturefill);
    }
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        $html.addClass("ie11");
    }


    /**
     * Ajax form send
     */
    $(document).on('submit', 'form.ajax', function (e) {
        e.preventDefault();
        var $frm = $(this);
        $.ajax({
            method: $frm.attr('method'),
            url: $frm.attr('action'),
            data: $frm.serialize()
        });
    });


    $.ajaxSetup({
        success: function (payload) {
            if (payload) {
                if (payload.snippets) {
                    for (var i in payload.snippets) {
                        var $snippet = $(payload.snippets[i]);

                        $("#" + i).replaceWith($snippet);

                        // ScrollReveal only observes elements present at page
                        // load - animate newly-inserted ones in now, as if they
                        // had just scrolled into view
                        window.srRevealGroup($snippet.find("[data-reveal]"));
                    }
                }
            }
        },
        dataType: 'json'
    });
})(jQuery);